module.exports = {

    components: {

        rowMeta: require('./formComponents/row-meta.vue').default,
        rowText: require('./formComponents/row-text.vue').default

    },

    props: {

        clinic: {
        	required: true
        },

        meta: {
        	required: true
        },

        payments: {

        },

        users: {

        },

        errors: {

        }

    },

    methods: {

        rowMetaComplete (type) {
            if (this.meta[type].forced == 1 || this.meta[type].value != null || this.meta[type].has_file == 1) {
                return true
            }
            return false
        },
        rowMetaCheckboxComplete (type) {
            if (this.meta[type].forced == 1 || (this.meta[type].value != null && this.meta[type].value != 0) || this.meta[type].has_file == 1) {
                return true
            }
            return false
        },
        validateRule (type) {
            const self = this

            if (self.gotFirstResponse == false) {
                console.error('self.gotFirstResponse == false')
                return false
            }

            if (type == 'rule_has_prices_internal') {
                if (self.rowMetaComplete('rule_has_prices_internal')) {
                    return true
                }

                if (self.payments && self.payments.periods[0]) {
                    var results = self.payments.periods[0].prices[1].filter(function (el) {
                        return el.account_id == 1 && el.price > 0
                    })

                    if (results.length > 0 || self.rowMetaComplete('rule_has_prices_internal')) {
                        return true
                    }
                }
            }

            if (type == 'rule_has_prices_external') {
                if (self.rowMetaComplete('rule_has_prices_external')) {
                    return true
                }

                if (self.payments && self.payments.periods[0]) {
                    var results = self.payments.periods[0].prices[2].filter(function (el) {
                        return el.account_id == 2 && el.price > 0
                    })

                    if (results.length > 0) {
                        return true
                    }
                }
            }

            if (type == 'rule_has_prices_pt') {
                if (self.rowMetaComplete('rule_has_prices_pt')) {
                    return true
                }

                if (self.payments && self.payments.periods[0]) {
                    var results = self.payments.periods[0].prices[4].filter(function (el) {
                        return el.account_id == 4 && el.price > 0
                    })

                    if (results.length > 0) {
                        return true
                    }
                }
            }

            if (type == 'rule_has_payment_account') {
                if ((self.clinic.payment_type && self.clinic.payment_account) || self.clinic.payment_exception == 1 || self.rowMetaComplete('rule_has_payment_account')) {
                    return true
                }
            }

            if (type == 'rule_contact') {
                if ((self.clinic.name_clinic &&
                    self.clinic.name_person &&
                    self.clinic.email &&
                    self.clinic.billing_phone &&
                    self.clinic.org_number) || self.rowMetaComplete('rule_contact')) {
                    return true
                }
            }

            if (type == 'show_contract') {

                /*
                Alla tidigare regler uppfyllda

                Alla prospect rader ska vara complete

                för avtal för mottagning måste mottagning ha pris samma för företag.
                */

            }

            if (type == 'do_trial_massage') {
                if (self.meta.trial_do && self.meta.trial_do.value != 0) {
                    return true
                }
            }

            if (type == 'rule_reconciliation') {
                if (self.rowMetaCheckboxComplete('checkbox_reconciliation_sign_in') &&
                    self.rowMetaCheckboxComplete('checkbox_reconciliation_payment_account') &&
                    self.rowMetaCheckboxComplete('checkbox_reconciliation_signature') &&
                    self.rowMetaCheckboxComplete('checkbox_reconciliation_recover_card') &&
                    self.rowMetaCheckboxComplete('checkbox_reconciliation_deviation')) {
                    return true
                }
            }
            if (type == 'rule_reconciliation_external') {
                if (self.rowMetaCheckboxComplete('checkbox_reconciliation_sign_in_external') &&
                    self.rowMetaCheckboxComplete('checkbox_reconciliation_payment_account_external') &&
                    self.rowMetaCheckboxComplete('checkbox_reconciliation_payment_invoice_external') &&
                    self.rowMetaCheckboxComplete('checkbox_reconciliation_timezynk_sign_in') &&
                    self.rowMetaCheckboxComplete('checkbox_reconciliation_timezynk_download') &&
                    self.rowMetaCheckboxComplete('checkbox_reconciliation_timezynk_schedule') &&
                    self.rowMetaCheckboxComplete('checkbox_reconciliation_timezynk_requests') &&
                    self.rowMetaCheckboxComplete('checkbox_reconciliation_timezynk_time_report')) {
                    return true
                }
            }
            if (type == 'rule_reconciliation_pt') {
                if (self.rowMetaCheckboxComplete('checkbox_reconciliation_payment_account_pt') &&
              self.rowMetaCheckboxComplete('checkbox_reconciliation_signature_pt') &&
              self.rowMetaCheckboxComplete('checkbox_reconciliation_recover_card_pt') &&
              self.rowMetaCheckboxComplete('checkbox_reconciliation_deviation_pt')) {
                    return true
                }
            }

            return false
        }

    }

}
